import React, { useState } from 'react';
import { bookAppointment } from '../utils/api';
import BookingSuccess from './BookingSuccess';
import '../styles/BookingForm.css';

function BookingForm({ selectedDate, selectedSlot, onBookingSuccess }) {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    currentSituation: '',
    problemToSolve: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [bookingSuccess, setBookingSuccess] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // 格式化日期为 YYYY-MM-DD 格式
      let formattedDate = '';
      if (selectedDate) {
        const year = selectedDate.getFullYear();
        const month = String(selectedDate.getMonth() + 1).padStart(2, '0');
        const day = String(selectedDate.getDate()).padStart(2, '0');
        formattedDate = `${year}-${month}-${day}`;
      }
      
      const appointmentData = {
        ...formData,
        date: formattedDate,
        startTime: selectedSlot.startTime,
        endTime: selectedSlot.endTime
      };

      console.log('Submitting appointment data:', appointmentData);

      const response = await bookAppointment(appointmentData);
      console.log('Booking response:', response);

      if (response.success && response.appointment) {
        setBookingSuccess(response.appointment);
        if (onBookingSuccess) {
          onBookingSuccess(response.appointment.id);
        }
      } else {
        setError(response.error || '预约失败，请重试');
      }
    } catch (error) {
      console.error('Booking error:', error);
      setError('预约失败，请重试');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  if (bookingSuccess) {
    return <BookingSuccess appointment={bookingSuccess} />;
  }

  return (
    <form onSubmit={handleSubmit} className="booking-form">
      <h3>预约信息</h3>
      <div className="form-group">
        <label htmlFor="name">姓名：</label>
        <input
          type="text"
          id="name"
          name="name"
          value={formData.name}
          onChange={handleInputChange}
          required
        />
      </div>

      <div className="form-group">
        <label htmlFor="phone">电话：</label>
        <input
          type="tel"
          id="phone"
          name="phone"
          value={formData.phone}
          onChange={handleInputChange}
          required
          pattern="^(\+\d{1,3})?\d{10,11}$"
        />
      </div>

      <div className="form-group">
        <label htmlFor="currentSituation">当前现状：</label>
        <textarea
          id="currentSituation"
          name="currentSituation"
          value={formData.currentSituation}
          onChange={handleInputChange}
          rows="3"
        />
      </div>

      <div className="form-group">
        <label htmlFor="problemToSolve">需要解决的问题：</label>
        <textarea
          id="problemToSolve"
          name="problemToSolve"
          value={formData.problemToSolve}
          onChange={handleInputChange}
          rows="3"
        />
      </div>

      {error && <div className="error-message">{error}</div>}

      <button type="submit" disabled={loading}>
        {loading ? '提交中...' : '确认预约'}
      </button>
    </form>
  );
}

export default BookingForm; 